// extracted by mini-css-extract-plugin
export default {"segmented":"Segmented_segmented__ld2wq","button":"Segmented_button__TMjbL","active":"Segmented_active__PznEs","disabled":"Segmented_disabled__ckMlF"};